import React from 'react';
import PropTypes from 'prop-types';

/**
 * StyledText - Text with black and white styling
 */
const GradientText = ({
  children,
  className = '',
  variant = 'primary',
  as = 'span',
  weight = 'bold',
  ...props
}) => {
  // Color variants
  const colorVariants = {
    primary: 'text-black',
    secondary: 'text-black',
    success: 'text-black',
    warning: 'text-black',
    danger: 'text-black',
    info: 'text-black',
    purple: 'text-black',
    sunset: 'text-black',
    ocean: 'text-black',
    forest: 'text-black',
    neon: 'text-black',
    fire: 'text-black',
    rainbow: 'text-black',
    white: 'text-white'};
  
  // Font weight
  const fontWeight = {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
    bold: 'font-bold',
    extrabold: 'font-extrabold'};
  
  // Base styles
  const baseStyles = `${colorVariants[variant]} ${fontWeight[weight]}`;
  
  // Render the component with the specified tag
  const Component = as;
  
  return (
    <Component className={`${baseStyles} ${className}`} {...props}>
      {children}
    </Component>
  );
};

GradientText.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary', 'secondary', 'success', 'warning', 'danger', 
    'info', 'purple', 'sunset', 'ocean', 'forest', 'neon', 'fire', 'rainbow', 'white'
  ]),
  as: PropTypes.oneOf(['span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div']),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold', 'bold', 'extrabold'])};

export default GradientText;
